import {Section} from '@primer/react-brand/esm'
import {ContentfulInlineFootnotesList} from '@github-ui/swp-core/components/contentful/ContentfulInlineFootnotesList'

export function FootnotesSection() {
  return (
    <Section paddingBlockStart="none" paddingBlockEnd="none" data-padding-inline>
      <ContentfulInlineFootnotesList />
    </Section>
  )
}
